"use client";

import Image from "next/image";

interface Props {
    onClick: () => void;
    emiAmount: string;
    tooltipText: string;
    TrackingEMI?: string;
    brand?: string;
    model?: string;
    version?: string;
    rightAction?: React.ReactNode;
    dataTestId?: string;
}

export default function EmiStartCard({
    onClick,
    emiAmount,
    tooltipText,
    TrackingEMI,
    brand,
    model,
    version = "v1",
    rightAction,
    dataTestId,
}: Props) {
    if (version === "v1") {
        return (
            <div className="px-3 lg:px-0 mb-3">
                <div className="bg-[#008C8B08] p-4 rounded-lg flex items-center justify-between border border-[#008C8B26] border-l-[2px]">
                    <div className="font-roboto font-normal text-[12px] md:text-[16px] leading-[18px] text-[#636975] flex items-center gap-1 md:gap-2">
                        EMI starts @
                        <span className="font-roboto font-extrabold text-[12px] md:text-[16px] leading-[18px] text-[#008C8B] flex items-center gap-1 md:gap-2">
                            ₹{emiAmount}/month
                            <span
                                className="group relative inline-flex items-center"
                                tabIndex={0}
                            >
                                <Image
                                    src={`${process.env.NEXT_PUBLIC_CDN_STATIC_URL}search-icons/exclamatory-white.svg`}
                                    alt="Next"
                                    width={14}
                                    height={14}
                                    className="border border-[#545454] rounded-full  cursor-pointer"
                                    title="exclamatory-white"
                                />
                                <span className="sr-only">{tooltipText}</span>
                                <span className="invisible absolute bottom-full left-1/2 z-10 mb-2 w-56 -translate-x-1/2 rounded-md bg-gray-900 px-3 py-2 text-[11px] font-normal leading-4 text-white opacity-0 shadow-lg transition-opacity duration-150 group-hover:visible group-hover:opacity-100 group-focus-within:visible group-focus-within:opacity-100">
                                    {tooltipText}
                                </span>
                            </span>
                        </span>
                    </div>

                    <button
                        className={`font-extrabold text-[14px] md:text-[16px] leading-[18px] text-[#0A86F1] rounded-lg cursor-pointer ${TrackingEMI}`}
                        onClick={onClick}
                        data-brand={brand}
                        data-model={model}
                    >
                        Calculate EMI
                    </button>
                </div>
            </div>
        );
    }

    if (version === "v2") {
        return (
            <div className="bg-[#F9F9F9] px-3 py-[8px] md:px-4 md:py-[14px] rounded-lg flex items-center justify-between gap-3 mt-4">
                <div className="flex flex-col items-start gap-2">
                    <span className="text-[13px] font-normal leading-[100%] flex items-center gap-[6px]">
                        EMI starts @{" "}
                        <span className="text-[13px] font-medium leading-[100%]">
                            ₹{emiAmount}/month
                        </span>
                        {tooltipText && (
                            <div className="group relative inline-flex items-center">
                                <Image
                                    src={`${process.env.NEXT_PUBLIC_CDN_STATIC_URL}search-icons/exclamatory-white.svg`}
                                    alt="exclamatory-icon"
                                    width={12}
                                    height={12}
                                    className="h-3.5 w-3.5 border border-[#545454] rounded-full  cursor-pointer rotate-[180deg]"
                                    aria-hidden="true"
                                    title="exclamatory-white"
                                />
                                <span className="sr-only">{tooltipText}</span>
                                <div className="invisible group-hover:visible absolute z-[9999] w-64 p-3 ml-2 text-xs text-black bg-white border border-gray-200 rounded-lg shadow-xl left-full top-1/2 -translate-y-1/2 text-left">
                                    {tooltipText}
                                    <div className="absolute w-2 h-2 bg-white border-l border-t border-gray-200 transform rotate-45 -left-1 top-1/2 -translate-y-1/2"></div>
                                </div>
                            </div>
                        )}
                    </span>

                    <button
                        className={`text-[13px] font-medium leading-[100%] text-[#155DFC] cursor-pointer ${TrackingEMI}`}
                        onClick={onClick}
                        data-brand={brand}
                        data-model={model}
                        data-testid={dataTestId}
                    >
                        Calculate EMI
                    </button>
                </div>

                {rightAction}
            </div>
        );
    }
}
